<template>
  <div class="monitoring-chart">
    <!-- 图表头部 -->
    <div
      class="flex flex-row items-center justify-between mb-4 pb-3 border-b border-gray-200 gap-0"
    >
      <h4 class="flex items-center text-base font-semibold text-gray-700">
        <component :is="IconComponent" :size="16" class="mr-2" />
        {{ title }}
      </h4>
      <!-- <span
        v-if="currentValue !== undefined"
        class="text-xl font-bold text-gray-900"
      >
        {{ currentValue }}
      </span> -->
    </div>

    <!-- 图表容器 -->
    <div class="relative">
      <div class="bg-gray-50 rounded-lg p-1 relative">
        <VChart
          v-if="props.option"
          :class="[
            'w-full transition-opacity duration-300',
            'opacity-100',
            height
          ]"
          :option="props.option"
          :autoresize="autoResize"
          :height="height"
          @ready="handleChartReady"
          @error="handleChartError"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  Activity,
  BarChart,
  TrendingUp,
  Zap,
  Cpu,
  HardDrive,
  MemoryStick,
  Network,
  Database,
  Server,
  Monitor,
  Gauge
} from 'lucide-vue-next'
import { computed } from 'vue'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart as BarChartS } from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart from 'vue-echarts'
import type { EChartsOption } from 'echarts'

// 注册必要的 ECharts 组件
use([
  CanvasRenderer,
  LineChart,
  BarChartS,
  GridComponent,
  TooltipComponent,
  LegendComponent
])

interface Props {
  title: string
  icon: string
  option: EChartsOption
  currentValue?: number | string
  height?: string
  autoResize?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  height: 'h-40',
  autoResize: true
})

// 图标映射
const iconComponentMap = {
  activity: Activity,
  'bar-chart': BarChart,
  'trending-up': TrendingUp,
  zap: Zap,
  cpu: Cpu,
  'hard-drive': HardDrive,
  'memory-stick': MemoryStick,
  network: Network,
  database: Database,
  server: Server,
  monitor: Monitor,
  gauge: Gauge
}

// 获取图标组件
const IconComponent = computed(() => {
  return (
    iconComponentMap[props.icon as keyof typeof iconComponentMap] || Activity
  )
})

// 图表事件处理
const handleChartReady = () => {}

const handleChartError = (err: any) => {
  console.error('Chart error:', err)
}
</script>

<style scoped></style>
